var captureModule = {
    vars: {
        groupName: "Documentos",
        docList: [],
        docPattern: "<div class='d-inline-flex'>\
                        <span cod='__id__' onclick='captureModule.capture.upload(this)' class='btn btn-secondary mb-3 mb-md-3 ml-0' style='margin-right:5px; margin-bottom:5px; cursor:pointer;'>\
                            <svg class='ico-upload ico-md' focusable='true'>\
                                <use xlink:href='#upload'></use>\
                            </svg > __doc__\
                        </span >\
                        <span class='bg-danger border border-light p-2 rounded-circle' style='width: 2px; height: 2px; right: 12px; position: relative; top: -6px;'>\
                            <span class='visually-hidden'></span>\
                        </span>\
                    </div>",
        docsHtml: "",
        docTypeList: [],
        uploadForDocType: false,
        modulePatternTemplate: '<tr>\
            <td>\
                <table id="customizedUpload" style="width:auto">\
                    <tbody>\
                        <tr style="display:none" class="group">\
                            <td class="group">__groupName__</td>\
                        </tr>\
                        <tr>\
                            <td style="display:none" class="col0"><div class="btn btn-primary btn-small" data-toggle="modal" data-target="#formalizationModal" >Adicionar</div></td>\
                            <td class="col1">__docsHtml__</td>\
                        </tr>\
                    </tbody>\
                </table>\
            </td>\
        </tr>',
        modulePattern: '',
        buttonsPattern: '<span id="btnsFormalization" style="float:right">\
            <span class="btn btn-default" onclick="captureModule.analisys.showForm()">Form</span>\
            <span class="btn btn-default" onclick="captureModule.analisys.showDocs()">Docs</span>\
            <span class="btn btn-default">Split</span>\
        </span>',
        modal: '<div id="formalizationModal" class="modal hide fade" style="width: 300px !important;margin-left: 25% !important;">\
        <div class="modal-header">\
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\
          <h3>Adicionar Documento</h3>\
        </div>\
        <div class="modal-body">\
            <label>Nome</label>\
            <input type="text" style="width:250px"></input>\
        </div>\
        <div class="modal-footer">\
          <span class="btn" data-dismiss="modal">Fechar</span>\
          <span class="btn btn-primary" onclick="captureModule.capture.modalSave()">Salvar</span>\
        </div>\
      </div>'
    },
    capture: {
        buildDocsHtml: function () {
            captureModule.vars.docsHtml = '';
            captureModule.vars.docList.forEach(function (doc) {
                captureModule.vars.docsHtml += captureModule.vars.docPattern.replace('__doc__', doc.Nome)
                    .replace(/__id__/g, doc.id);
            });
            captureModule.vars.modulePattern = captureModule.vars.modulePatternTemplate;
            captureModule.vars.modulePattern =
                captureModule.vars.modulePattern.replace('__docsHtml__', captureModule.vars.docsHtml)
                    .replace('__groupName__', captureModule.vars.groupName);
        },
        appendModule: function () {
            var formExecute = document.querySelector("#ContainerAttach, #containerFiles");

            if (formExecute == null) return;

            var customUpload = formExecute.querySelectorAll('#customizedUpload');

            if (customUpload.length > 0) {
                customUpload[0].parentNode.removeChild(customUpload[0]);
            }

            formExecute.querySelector(".box-header, #mandatoryAnnex").insertAdjacentHTML("beforeend", captureModule.vars.modulePattern);

            if (document.querySelectorAll('#formalizationModal').length > 0) {
                return;
            }
            document.querySelector('.container-task').insertAdjacentHTML("beforeend", captureModule.vars.modal);

        },
        upload: function (e) {
            let cod = e.getAttribute('cod');
            if (document.querySelectorAll(`#customizedUpload span.btn[cod="${cod}"]`).length > 0) {
                if (!e.nextElementSibling.classList.contains('bg-success') && document.querySelector(`#customizedUpload span.btn[cod="${cod}"]`).getAttribute('show') !== 'n') {
                    document.querySelectorAll('#customizedUpload span.btn').forEach((element) => {
                        element.classList.remove('last');
                    });
                    e.classList.add('last');
                    captureModule.vars.uploadForDocType = true;
                    let docType = e.innerText.split('>')[0].trim();

                    let executionMode = document.querySelector('#inpDsExecutionMode').value;
                    if (executionMode.trim() == '2.0')
                        execv2.files.openUploader(null, docType);
                    else
                        uploadFiles(docType);
                } else {
                    captureModule.capture.showUpload(cod);
                }
            }
        },
        modalSave: function () {
            var name = document.querySelector('#formalizationModal input').value;
            this.addDoc(name, true);
        },
        addDoc: function (name, added) {
            var id = ++document.querySelectorAll('#customizedUpload .col1 div').length;
            if (!isEmpty(name)) {
                document.querySelector('#customizedUpload .col1').insertAdjacentHTML("beforeend", captureModule.vars.docPattern.replace('__id__', id).replace('__doc__', name));
                document.querySelector('#formalizationModal input').value = "";
                $('#formalizationModal').modal('hide');
                if (added) {
                    document.querySelector('#customizedUpload .col1 div:last-child').setAttribute('added', 'true');
                    document.querySelector('#customizedUpload .col1 div:last-child').insertAdjacentHTML("beforeend", `<div>  <span class="icon-minus-sign" onclick="captureModule.capture.removeDoc(${id})"></span></div>`);
                }
            }
        },
        removeDoc: function (id) {
            $(`#annex .filename  a[cod="${id}"]`).closest('tr').find('.delFile').trigger('click');
            if ($(`#annex .filename  a[cod="${id}"]`).length === 0) {
                $(`#customizedUpload .col1 span[cod="${id}"]`).remove();
            }
        },
        init: function () {

        },
        uploadChange: function () {

            var targetNode = document.querySelector('#annex');

            if (!targetNode) {
                return;
            }

            var observerOptions = {
                childList: true,
                attributes: false,
                subtree: true
            };

            var observer = new MutationObserver(function (m) {
                if ($('.last').length > 0) {
                    var cod = $('.last')[0].getAttribute('cod');
                    var customizedUpload;
                    if (m[0].addedNodes.length > 0) {
                        if (!captureModule.vars.uploadForDocType)
                            return;

                        let files = document.querySelectorAll('#annex .message a');
                        files[files.length - 1].setAttribute('cod', cod);
                        customizedUpload = document.querySelector(`#customizedUpload span.btn[cod="${cod}"]`);
                        customizedUpload.nextElementSibling.classList.remove('bg-danger');
                        customizedUpload.nextElementSibling.classList.add('bg-success');
                        customizedUpload.insertAdjacentHTML('beforeend', `<div>   <span class="icon-remove" onclick="captureModule.capture.removeUpload(${cod})"></span></div>`);
                    } else if (m[0].removedNodes.length > 0) {
                        cod = m[0].removedNodes[0].querySelectorAll('td')[2].querySelector('a').getAttribute('cod');
                        customizedUpload = document.querySelector(`#customizedUpload span.btn[cod="${cod}"]`);
                    }
                }
                captureModule.vars.uploadForDocType = false;
            });

            observer.observe(targetNode, observerOptions);

        },
        showUpload: function (cod) {
            var customizedUpload = document.querySelector(`#customizedUpload span.btn[cod="${cod}"]`);
            if (customizedUpload.getAttribute('show') !== 'n') {
                document.querySelector(`#annex .message  a[cod="${cod}"]`).click();
            }
            customizedUpload.removeAttribute('show');
        },
        removeUpload: function (cod) {

            document.querySelectorAll('#customizedUpload span.btn').forEach((element) => {
                element.classList.remove('last');
            });
            document.querySelector(`#customizedUpload span.btn[cod="${cod}"]`).classList.add('last');
            document.querySelector(`#customizedUpload span.btn[cod="${cod}"]`).setAttribute('show', 'n');

            let r = document.querySelector(`#annex .message-box a[cod="${cod}"]`).closest('tr').querySelector('.text-danger').parentElement.click();
        },
        buildModal: function () {

            if (document.querySelectorAll('#uploadModal').length > 0) {
                return;
            }

            document.querySelector('body form').insertAdjacentHTML('beforeend', '<div id="uploadModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">\
                  <div class="modal-dialog modal-lg">\
                    <div class="modal-content">\
                    </div>\
                  </div>\
                </div>');
            document.querySelector('head').insertAdjacentHTML('beforeend','<style type="text/css">.modal{left:5% !important;width:90% !important;margin-left:0 !important}</style>');
        },
        validateFilesImported: function () {
            const annex = document.getElementById('annex');
            const annexFiles = annex ? Array.from(annex.querySelectorAll('[name=inpDsFileName]')) : [];

            if (!annex)
                return;

            if (annex && annexFiles.length === 0) {
                // Observer para detectar quando arquivos forem renderizados
                const observer = new MutationObserver(function (mutationsList, observer) {
                    const checkedFiles = Array.from(annex.querySelectorAll('[name=inpDsFileName]'));
                    if (checkedFiles.length > 0) {
                        captureModule.capture.validateFilesImported();
                        observer.disconnect();
                    }
                });
                observer.observe(annex, { childList: true, subtree: true });
                return;
            }

            const mandatoryFields = Array.from(document.querySelectorAll('#customizedUpload span.btn'));
            const filesPath = Array.from(annex.querySelectorAll('.message-box a'));
            let docTypeList = captureModule.vars.docTypeList.slice();

            mandatoryFields.forEach((field) => {
                const fieldDocType = field.innerText.trim();
                annexFiles.forEach((fileInput, fileInputIdx) => {
                    const fileParts = fileInput.value.split(';');
                    const fieldName = fileParts[5];
                    if (!fieldName || fieldName.trim() === '') return;
                    const fileName = execv2.util.rewriteConcatToText(fieldName.trim());
                    if (fileName === fieldDocType) {
                        const cod = field.getAttribute('cod');
                        if (filesPath[fileInputIdx]) filesPath[fileInputIdx].setAttribute('cod', cod);
                        setUploadSucess(field);
                        if (!field.querySelector('.icon-remove')) {
                            field.insertAdjacentHTML("beforeend", `<div><span class="icon-remove" onclick="captureModule.capture.removeUpload(${cod})"></span></div>`);
                        }
                    }
                });
                docTypeList = docTypeList.filter(doc => doc.docType !== fieldDocType);
            });

            docTypeList.forEach(doc => {
                // P/ cada tipo de documento n�o anexado, tenta encontrar o campo correspondente e apaga o arquivo, se necess�rio
                const linkMatched = mandatoryFields.find(link => link.getAttribute('cod') === doc.cod);
                if (linkMatched) {
                    const tr = linkMatched.closest('tr');
                    const delBtn = tr?.querySelector('.text-danger')?.parentElement;
                    if (delBtn) delFile(delBtn);
                }
            });

            function setUploadSucess(field) {
                if (!field) return;
                if (field.nextElementSibling) {
                    field.nextElementSibling.classList.remove('bg-danger');
                    field.nextElementSibling.classList.add('bg-success');
                }
            }
        },
        populateDocTypeList: function () {
            captureModule.vars.docTypeList = [];
            for (var i = 0; i < document.querySelectorAll('#customizedUpload span.btn').length; i++) {
                captureModule.vars.docTypeList.push({ docType: document.querySelectorAll('#customizedUpload span.btn')[i].innerText.trim(), cod: document.querySelectorAll('#customizedUpload span.btn')[i].getAttribute('cod') });
            }
        },
        load: function () {
            this.buildDocsHtml();
            this.appendModule();
            this.uploadChange();
            this.buildModal();
            this.validateFilesImported();
            this.populateDocTypeList();
            this.loadFilesSaved();
        },
        loadFilesSaved: function () {

            var uploaded = [];

            document.querySelectorAll(".docType").forEach(function (item) {
                uploaded.push(item.innerText.trim());
            });

            document.querySelectorAll("#customizedUpload span.btn").forEach(function (item) {
                if (uploaded.indexOf(item.innerText.trim()) !== -1) {
                    var cod = item.getAttribute("cod");
                    var customizedUpload = document.querySelector(`#customizedUpload span[cod="${cod}"]`);
                    customizedUpload.nextElementSibling.classList.remove("bg-danger");
                    customizedUpload.nextElementSibling.classList.add("bg-success");
                }
            });

        }
    }
};